
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UnitConverter from '../../../mixins/unitConverter'
import ProjectHeatMapChart from '../ProjectHeatMapChart'
import { printHeatMap2, printHeatMapExcel } from '@/printHeatMap'


@Component({
  components: {
   'heat-map': ProjectHeatMapChart,
  },
  mixins:[UnitConverter]
})
export default class ProjectHeatMap extends Vue {
    @Prop({default: 'Drilling Sequence Report Sheet'})
    sequence_name !: string
    @Prop()
    projects: any

    tableID: string = 'heatmap'
    newTab () {
        var wnd = window.open("", "_blank", "scrollbars,menubar,toolbar,status") as any;
        const div = this.$refs.printDiv as any
        wnd.document.write(div.outerHTML);
        wnd.document.close();
        return false
    }
    printPDF  () {
        const printDiv = this.$refs.printDiv as any;
        const newWindow = window.open('') as any;
        newWindow.document.write(printDiv.outerHTML);
        newWindow.print();
        newWindow.close();
    }

    printExcel() {
        return printHeatMapExcel(this.sequence_name, this.tableID);
    }

    print() {
        return printHeatMap2(this.sequence_name, this.tableID)
    }

    sendInMail(){
        printHeatMap2(this.sequence_name, this.tableID, true)
        .then((generatedFile: any) => {
            if (generatedFile) {
                this.$emit("sendMail", { file: generatedFile });
            }
        })
        .catch((error:any) => {
            // console.error("Error generating file for email:", error);
        });
    }

    close () {
        const modal = this.$refs.modal as any
        modal.hide()
    }

}
